import Category from "@/models/Category";
import Tag from "@/models/Tag";
import Task, { TaskPriority, TaskStatus } from "@/models/Task";
import moment from "moment";
import { StorageService } from "./StorageService";

export class DummyStorageService implements StorageService {
  tasks: Task[];
  categories: Category[];
  tags: Tag[];

  constructor(initialData?: {
    tasks?: Task[];
    categories?: Category[];
    tags?: Tag[];
  }) {
    this.tasks = initialData?.tasks || [];
    this.categories = initialData?.categories || [];
    this.tags = initialData?.tags || [];
  }

  async getTasks(): Promise<Task[]> {
    return this.tasks;
  }
  async getCategories(): Promise<Category[]> {
    return this.categories;
  }
  async getTags(): Promise<Tag[]> {
    return this.tags;
  }
  async saveTasks(tasks: Task[]): Promise<void> {
    this.tasks = tasks;
  }
  async saveCategories(categories: Category[]): Promise<void> {
    this.categories = categories;
  }
  async saveTags(tags: Tag[]): Promise<void> {
    this.tags = tags;
  }

  static DUMMY_INITIAL_DATA = {
    categories: [
      new Category({
        id: "work",
        name: "Work",
      }),
      new Category({
        id: "personal",
        name: "Personal",
      }),
    ],
    tags: [
      new Tag({
        id: "shopping",
        name: "Shopping",
        color: "#FF5733",
      }),
      new Tag({
        id: "errands",
        name: "Errands",
        color: "#33FF57",
      }),
      new Tag({
        id: "work",
        name: "Work",
        color: "#3357FF",
      }),
    ],
    tasks: [
      new Task({
        id: "1",
        title: "Buy groceries",
        description: "Milk, Bread, Cheese, Eggs",
        status: TaskStatus.TODO,
        dueDate: moment().add(3, "days"),
        priority: TaskPriority.MEDIUM,
        createdAt: moment().subtract(2, "days"),
        updatedAt: moment().subtract(1, "days"),
        deletedAt: null,
        tagsIds: ["shopping", "errands"],
        categoryId: "personal",
      }),
      new Task({
        id: "2",
        title: "Finish project report",
        description: "Complete the final draft and send to manager",
        status: TaskStatus.IN_PROGRESS,
        dueDate: moment().subtract(1, "days"),
        priority: TaskPriority.HIGH,
        createdAt: moment().subtract(5, "days"),
        updatedAt: moment().subtract(1, "days"),
        deletedAt: null,
        tagsIds: ["work"],
        categoryId: "work",
      }),
      new Task({
        id: "3",
        title: "Call plumber",
        description: "Fix the kitchen sink leak",
        status: TaskStatus.DONE,
        dueDate: null,
        priority: TaskPriority.LOW,
        createdAt: moment().subtract(7, "days"),
        updatedAt: moment().subtract(2, "days"),
        deletedAt: null,
        tagsIds: [],
        categoryId: null,
      }),
    ],
  };
}
